// extracted by mini-css-extract-plugin
export default {"container":"iYG_V"};